import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SchoolMealPage from './SchoolMealPage';  // 급식 페이지
import SchoolSchedulePage from './SchoolSchedulePage';  // 학사일정 페이지
import SchoolTimetablePage from './SchoolTimetablePage';  // 학사일정 페이지
import './App.css';  // CSS 파일 임포트

const App = () => {
  return (
    <Router>
      <Routes>
        {/* 급식 페이지 라우트 */}
        <Route path="/school-meal" element={<SchoolMealPage />} />
        
        {/* 학사일정 페이지 라우트 */}
        <Route path="/schedule" element={<SchoolSchedulePage />} />
        <Route path="/timetable" element={<SchoolTimetablePage />} />

        {/* 기본 홈 페이지 */}
        <Route path="/" element={<SchoolMealPage />} />
      </Routes>
    </Router>
  );
};

export default App;
